import MyInformation from "@/components/modules/account/my-information";
import { __, getPermalink } from "@/lib/i18n/functions";
import Link from "next/link";

type AccountInformationProps = {
  resolution: Resolution;
};

const AccountInformation = ({ resolution }: AccountInformationProps) => {
  const locale = resolution?.locale;
  return (
    <article className="text-dark-primary flex-1/2 space-y-[70px]">
      <MyInformation locale={resolution.locale} />
      <section className="space-y-5">
        <div className="flex items-center justify-between">
          <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">{__("Security", locale)}</h2>
          <Link
            href={getPermalink(locale, "forgot-password")}
            className="focus-visible:ring-dark-primary/70 cursor-pointer rounded-sm underline outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          >
            {__("Reset password", locale)}
          </Link>
        </div>
        <dl>
          <div className="flex gap-1.5">
            <dt>{__("Password", locale)} : </dt>
            <dd className="font-semibold">*********</dd>
          </div>
        </dl>
      </section>
    </article>
  );
};

export default AccountInformation;
